export const decisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/first_recommendation_run";
